import React, { useState } from 'react';
import { Button } from '@getro/rombo';
import { Mail } from 'lucide-react';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { SocialOAuthButtons } from '../../../components/molecules/socialOAuthButtons';
import { userSelector } from '../../../redux/selectors';
import { OAuthMessageError } from '../../../components/molecules/oAuthMessageError';
import UserAndCompanyProfile from './UserAndCompanyProfile';

export const SignUp = ({ routePath, network }) => {
  const [oAuthError, setOAuthError] = useState(null);
  const { email } = useSelector(userSelector) || {};
  const history = useHistory();

  const onClickSignUp = (mode) => {
    history.push(`${routePath}/profile/${mode}`);
  };

  return (
    <Flex sx={{ flexDirection: 'column', gap: '40px' }}>
      <Flex sx={{ flexDirection: 'column', gap: '16px', flex: 1 }}>
        {network && <UserAndCompanyProfile network={network} />}
        <Text sx={{ fontWeight: 600, fontSize: '22px', color: 'text.dark', lineHeight: '1.4' }}>
          Start collaborating with {network?.name}
        </Text>
        <Text>
          Share your contacts with them on Getro, so they can find high-impact introductions between them and their
          network.
        </Text>
      </Flex>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <Text fontSize="14px" color="text.dark">
          You were invited at{' '}
          <Text as="span" fontWeight="medium">
            {email}
          </Text>
          , use it to sign up.
        </Text>
        <SocialOAuthButtons
          onSuccess={() => {
            setOAuthError(null);
            onClickSignUp('social');
          }}
          onError={(e) => {
            setOAuthError(e);
          }}
        />
        <Button
          icon={Mail}
          variant="secondary"
          width="100%"
          sx={{ gap: '16px', justifyContent: 'center' }}
          onClick={() => onClickSignUp('email')}
        >
          Sign up with email
        </Button>
        {!!oAuthError && <OAuthMessageError oAuthError={oAuthError} email={email} />}
      </Box>
    </Flex>
  );
};

SignUp.propTypes = {
  routePath: PropTypes.string.isRequired,
  network: PropTypes.object.isRequired,
};
